export default {
    'searchList': {
        'searchTxt': [{
            'name': '客户订单号',
            'value': 'ettaSoNo',
            'type': 'input',
            'unfold': true,
            'span': 3
        }, {
            'name': '发车单号',
            'value': 'ettaDoNo',
            'type': 'input',
            'unfold': true,
            'span': 3
        }, {
            'name': '物流订单号',
            'value': 'ettaOrderNo',
            'type': 'input',
            'unfold': true,
            'span': 3
        }, {
            'name': '创建时间',
            'value': 'createTime',
            'startTime': 'createTimeFrom',
            'endTime': 'createTimeTo',
            'startPlaceholder': '创建开始日期',
            'endPlaceholder': '创建结束日期',
            'timeNum': 30,
            'type': 'time',
            'unfold': true,
            'span': 7
        }],
        'unfoldState': false,
        'advancedBtn': true
    },
    'table':
    {
        'clickState': false,
        'selectBtn': true,
        'height': 400,
        'columns': [
            {
                'label': '客户订单号',
                'prop': 'ettaSoNo',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '运单号',
                'prop': 'ettaWorkOrderNo',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '是否预约',
                'prop': 'ettaReservationType',
                'sort': true,
                'width': '80px'
            },
            {
                'label': '预约异常',
                'prop': 'businessCodeType',
                'sort': true,
                'width': '80px'
            },
            {
                'label': '配送异常',
                'prop': 'dispatchingAbnormalCode',
                'sort': true,
                'width': '80px'
            },
            {
                'label': '运输单状态',
                'prop': 'ettaStatusType',
                'sort': true,
                'width': '100px'
            },
            {
                'label': '排队ID',
                'prop': 'queueCode',
                'sort': true,
                'width': '100px'
            },
            {
                'label': '收货人',
                'prop': 'ettaToContactName',
                'sort': true,
                'width': '100px'
            },
            {
                'label': '收货手机',
                'prop': 'ettaToContactCombin',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '收货市',
                'prop': 'esstToCityName',
                'sort': true,
                'width': '102px'
            },
            {
                'label': '收货区县',
                'prop': 'esstToDistrictName',
                'sort': true,
                'width': '102px'
            },
            {
                'label': '送货地址',
                'prop': 'ettaEtorToEbrgAddress',
                'sort': true,
                'width': '182px'
            },
            {
                'label': '线路',
                'prop': 'ettaEblnLineName',
                'sort': true,
                'width': '120px'
            },
            {
                'label': '商品型号',
                'prop': 'ettmEbmaNameCn',
                'sort': true,
                'width': '120px'
            },
            {
                'label': '体积',
                'prop': 'ettaVolume',
                'sort': true,
                'width': '120px'
            },
            {
                'label': '重量',
                'prop': 'ettaWeight',
                'sort': true,
                'width': '120px'
            },
            {
                'label': '要求发货时间',
                'prop': 'ettaReqDeliveryDate',
                'sort': true,
                'width': '120px'
            },
            {
                'label': '要求送达时间',
                'prop': 'ettaReqArrivalDate',
                'sort': true,
                'width': '120px'
            },
            {
                'label': '预约送货时间',
                'prop': 'ettaReservationTime',
                'sort': true,
                'width': '120px'
            },
            {
                'label': 'C端配送方式',
                'prop': 'ettaDeliveryTypeCodeType',
                'sort': true,
                'width': '120px'
            },
            {
                'label': '是否供方预约',
                'prop': 'etIsSupllyAppointmentType',
                'sort': true,
                'width': '120px'
            },
            {
                'label': '客户',
                'prop': 'ettaCustomEbcuNameCn',
                'sort': true,
                'width': '120px'
            },
            {
                'label': '分公司',
                'prop': 'companyName',
                'sort': true,
                'width': '120px'
            },
            {
                'label': '服务平台',
                'prop': 'siteName',
                'sort': true,
                'width': '120px'
            },
            {
                'label': '创建时间',
                'prop': 'createTime',
                'sort': true,
                'width': '120px'
            },
            {
                'label': '运输单号',
                'prop': 'ettaNo',
                'sort': true,
                'width': '120px'
            },
            {
                'label': '发车单号',
                'prop': 'ettaDoNo',
                'sort': true,
                'width': '120px'
            },
            {
                'label': '集拼号',
                'prop': 'ettaAssighNo',
                'sort': true,
                'width': '120px'
            },
            {
                'label': '物流订单号',
                'prop': 'ettaOrderNo',
                'sort': true,
                'width': '120px'
            },
            {
                'label': '备注',
                'prop': 'ettaRemark',
                'sort': true,
                'width': '120px'
            }]
    },
    'page': {
        'layout': 'total, sizes, prev, pager, next, jumper',
        'pageSize': 10,
        'pageSizes': [10, 20, 30, 50, 100] // eslint-disable-line
    },
    'searchTotalTitle': [
        {
            'name': '是否菜鸟',
            'value': 'cainiaoyn',
            'type': 'select',
            'span': 3,
            'optionNum': 'SYS_SUPPLIER_YES_NO',
            'multiple': false
        }, {
            'name': '客户',
            'value': 'ebcuNameCn',
            'type': 'advance',
            'advanceConfig': [
                { 'prop': 'ebcuNameCn', 'value': '客户名称' },
                { 'prop': 'pmCode', 'value': '客户编码' }
            ],
            'tableConfig': [
                { 'prop': 'pmCode', 'value': '客户编码' },
                { 'prop': 'ebcuNameCn', 'value': '客户名称' }
            ],
            'advanceUrl': '/ebCustomer/searchByEbCustomer',
            'cbParams': ['pmCode#ettaCustomEbcuNo', 'ebcuNameCn'],
            'span': 4
        }, {
            'name': '线路',
            'value': 'eblnLineName',
            'type': 'advance',
            'advanceConfig': [
                { 'prop': 'eblnLineCode', 'value': '代码' },
                { 'prop': 'eblnLineName', 'value': '名称' }
            ],
            'tableConfig': [
                { 'prop': 'eblnLineCode', 'value': '代码' },
                { 'prop': 'eblnLineName', 'value': '名称' },
                { 'prop': 'eblnRatedMileage', 'value': '额定里程' }
            ],
            'advanceUrl': '/ebLine/search',
            'cbParams': ['eblnLineCode#ettaEblnCode', 'eblnLineName', 'eblnRatedMileage'],
            'span': 4
        }, {
            'name': '运输单状态',
            'value': 'ettaStatus',
            'type': 'select',
            'span': 3,
            'optionNum': 'SYS_TRANSPORT_TASK_STATUS',
            'multiple': false
        }, {
            'name': '是否预约',
            'value': 'ettaReservation',
            'type': 'select',
            'data': '0',
            'span': 3,
            'optionNum': 'SYS_SUPPLIER_YES_NO',
            'multiple': false
        }, {
            'name': 'C端配送方式',
            'value': 'ettaDeliveryTypeCode',
            'type': 'select',
            'data': 'WAREHOUSEMATCHING',
            'span': 3,
            'optionNum': 'OMS_TRANS_TYPE',
            'multiple': false
        }, {
            'name': '是否分拨',
            'value': 'ettaIsAllot',
            'data': '0',
            'type': 'select',
            'span': 3,
            'optionNum': 'SYS_SUPPLIER_YES_NO',
            'multiple': false
        }, {
            'name': '收货市',
            'value': 'ebplNameCn1',
            'type': 'advance',
            'advanceConfig': [
                { 'prop': 'ebplNameCn', 'value': '目的地市名称' },
                { 'prop': 'ebplCode', 'value': '目的地市编码' }
            ],
            'tableConfig': [
                { 'prop': 'ebplNameCn', 'value': '目的地省名称' },
                { 'prop': 'ebplCode', 'value': '目的地市编码' }
            ],
            'cbParams': [
                'ebplCode#esstToCityCode', 'ebplNameCn#ebplNameCn1'
            ],
            'advanceUrl': '/searchEbPlacePage?ebplType=PLACE_CITY',
            'advanceCode': 'esstToCityCode'
        }, {
            'name': '收货区县',
            'value': 'ebplNameCn2',
            'type': 'advance',
            'advanceConfig': [
                { 'prop': 'ebplNameCn', 'value': '目的地区名称' },
                { 'prop': 'ebplCode', 'value': '目的地区编码' }
            ],
            'tableConfig': [
                { 'prop': 'ebplNameCn', 'value': '目的地区名称' },
                { 'prop': 'ebplCode', 'value': '目的地区编码' }
            ],
            'cbParams': [
                'ebplCode#esstToDistrictCode', 'ebplNameCn#ebplNameCn2'
            ],
            'advanceUrl': '/searchEbPlacePage?ebplType=PLACE_DISTRICT',
            'advanceCode': 'esstToDistrictCode'
        }
    ]
};
